export const ROWS = [
  ["A", "Kümülatif İmalat Tutarı"], ["B", "İlave İşler"], ["C", "Kümülatif Hakediş Toplam Tutarı", true],
  ["D", "Bir Önceki Hakediş Toplam Tutarı"], ["E", "Bu Hakediş Tutarı (KDV Hariç)", true], ["F", "KDV Tutarı"],
  ["G", "Bu Hakediş Tutarı (KDV Dahil)", true], ["H", "Nakit Teminat Kesintisi"], ["I", "KDV Tevkifatı"],
  ["J", "Stopaj Kesintisi"], ["K", "Avans Kesintisi"], ["L", "SGK Prim Kesintisi"], ["M", "Diğer Kesintiler"],
  ["N", "Kesintiler Toplamı", true], ["O", "Bu Hakedişte Ödenecek Tutar", true], ["P1", "Katılım Payı Kesintisi"],
  ["P2", "Gecikme Cezası"], ["P3", "Diğer Cezalar"], ["P4", "Yemek Kesintileri"], ["P5", "İSG Hizmet Kesintisi"],
  ["P6", "İSG Cezası"], ["P7", "Tutanaklı Kesintiler"], ["P8", "Diğer Kesintiler (Fatura)"],
  ["P", "Fatura/Dekont Edilecek Kesintiler", true], ["R", "ÖDENECEK NET TUTAR", true],
];

export const P_FIELDS = [["p2", "P2 Gecikme Cezası"], ["p3", "P3 Diğer Cezalar"], ["p4", "P4 Yemek"], ["p5", "P5 İSG Hizmet"],
  ["p6", "P6 İSG Cezası"], ["p7", "P7 Tutanaklı"], ["p8", "P8 Diğer (Fatura)"]];

export const RATE_FIELDS = [["kdv", "KDV"], ["tevkifat", "KDV Tevkifatı"], ["teminat", "Nakit Teminat"], ["stopaj", "Stopaj"],
  ["katilim", "Katılım Payı"], ["sgk_rate", "Asgari İşçilik"], ["sgk_prim", "SGK Prim Oranı"]];

export const DEFAULT_RATES = { kdv: 0.2, tevkifat: 0.4, teminat: 0.05, stopaj: 0, katilim: 0.015, sgk_rate: 0.09, sgk_prim: 0.345 };

export const STEPS = [["hazirlandi", "Hazırlandı"], ["kontrol", "Kontrol"], ["onay", "Onay"], ["odendi", "Ödendi"]];
export const LOCKED = ["onay", "odendi"];

export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2));

export const plabel = (p) => p?.label || `${p?.no} NOLU`;
